var portfolioTransactionEdit = {
	title: "Modifica transazione",
	subTitle: "Portafoglio: {name}",
	buy: "Acquisto",
	sell: "Vendita",
	buyDate: "Data di Acquisto",
	sellDate: "Data di Vendita",
	quantity: "Quantità/Nominale",
	buyPrice: "Prezzo Acquisto",
	exchangeRate: "Tasso di cambio",
	exchangeRateFormat: "{from}/{to}",
	confirmBtn: "Ok",
	cancelBtn: "Annulla",
	buyValueInPortfolioCurrency: "Valore Acquisto (valuta del portafoglio)",
	buyValueInNotationCurrency: "Valore Acquisto (valuta di quotazione)",
	sellValueInPortfolioCurrency: "Valore Vendita (valuta del portafoglio)",
	sellValueInNotationCurrency: "Valore Vendita (valuta di quotazione)",
	transactionType: "Tipologia di Transazione",
	sellPrice: "Prezzo Vendita",
	validationErrors: {
		buyDate: {
			invalidInput: "Formato della data non valido. Formato valido aaaa-MM-gg'T'OO: mm"
		},
		buyPrice: {
			invalidInput: "Prezzo non valido"
		},
		exchangeRate: {
			invalidInput: "Tasso di cambio non valido"
		},
		quantity: {
			invalidInput: "Quantità non valida"
		}
	}
};
var it = {
	portfolioTransactionEdit: portfolioTransactionEdit
};

export { it as default, portfolioTransactionEdit };
